export const SET_DEVICE_VIDEO = "SET_DEVICE_VIDEO";
export const SET_DEVICE_AUDIO = "SET_DEVICE_AUDIO";
export const SET_DEVICE_SCREEN_STREAM = "SET_DEVICE_SCREEN_STREAM";
export const SET_DEVICE_CAM_STREAM = "SET_DEVICE_CAM_STREAM";
export const SET_DEVICE_INIT = "SET_DEVICE_INIT";
